export default "__VITE_ASSET__CrGVPlJ8__"